const ERROR_MESSAGES = {
	ELEMENT_NOT_FOUND: 'RunningText: Required elements not found',
	INIT_FAILED: 'RunningText: Initialization failed'
};

const CONFIG = {
	DUPLICATES_NEEDED: 10
};

/**
 * Initialize running text animation
 * @returns {void}
 */
const initializeRunningText = () => {
	const container = document.querySelector('.running-text');
	const text = container?.querySelector('.running-text__item');

	if (!container || !text) {
		console.warn(ERROR_MESSAGES.ELEMENT_NOT_FOUND);
		return;
	}

	try {
		// Clear existing content
		container.innerHTML = '';

		// Create document fragment for better performance
		const fragment = document.createDocumentFragment();

		// Create and append duplicates
		for (let i = 0; i < CONFIG.DUPLICATES_NEEDED; i++) {
			const clone = text.cloneNode(true);
			fragment.appendChild(clone);
		}

		// Append all clones at once
		container.appendChild(fragment);
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

export { initializeRunningText };
